import * as React from 'react';
import { SVGProps } from 'react';

const SvgSortingDownwardsOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="M6.313 10h11.374a.75.75 0 0 0 .572-.264.896.896 0 0 0 .241-.625c0-.24-.08-.449-.241-.625L12.57 2.264a.75.75 0 0 0-1.142 0L5.74 8.486a.896.896 0 0 0-.241.625c0 .24.08.45.241.625a.75.75 0 0 0 .572.264Z"
      fill="currentColor"
    />
    <path
      d="M17.687 14H6.313a.75.75 0 0 0-.572.264.895.895 0 0 0-.241.625c0 .24.08.449.241.625l5.688 6.222a.75.75 0 0 0 1.142 0l5.688-6.222a.897.897 0 0 0 .241-.625c0-.241-.08-.45-.241-.625a.75.75 0 0 0-.572-.264Z"
      fill="#8E93AF"
    />
  </svg>
);

export default SvgSortingDownwardsOutlined;
